import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import {optionsTemplate} from "../../utils/formatters";
import Select from "../form/Select";
import {stockEditor as StockEditor} from "./stockEditor";
import {set} from "../../utils/dotutils";

class FilteredStockEditor extends React.Component {

    clearStoreSelector = () => {
        this.props.setFieldValue("store", null);
    }

    setFieldValue = (field, value) => {
        const values = {...this.props.values};
        set(values, field, value);
        this.props.setFormValues(values);
    }

    render() {
        return (
            <Fragment>
                <div className="row form-row">
                    <div className="col-md-6">
                        <Select
                            label="Partner"
                            placeholder="Szűrj partnerre"
                            name="partner"
                            component="partner"
                            isClearable={true}
                            isMulti={false}
                            objectValue={true}
                            labelKey="name"
                            storeType="remote"
                            optionsTemplate={optionsTemplate("partner")}
                            value={this.props.values.partner}
                            onSelect={this.clearStoreSelector}
                            saveChanges={this.setFieldValue}
                        />
                    </div>
                    {
                        this.props.values.partner &&
                        <div className="col-md-6">
                            <Select
                                label="Raktár"
                                placeholder="Szűrj raktárra"
                                name="store"
                                component="store"
                                isClearable={true}
                                isMulti={true}
                                objectValue={true}
                                labelKey="name"
                                storeType="local"
                                optionsTemplate={optionsTemplate("location")}
                                value={this.props.values.store}
                                saveChanges={this.setFieldValue}
                                filter={[{field: "partner_id", value: this.props.values.partner.partner_id}]}
                            />
                        </div>
                    }
                </div>
                <StockEditor
                    {...this.props}
                    partner_id={this.props.values.partner && this.props.values.partner.partner_id || undefined}
                    store_id={this.props.values.store || undefined}
                />
            </Fragment>

        );
    }
}

export default createEditor({componentName: "StockItem", WrappedComponent: FilteredStockEditor, editor: "stock"});

